import React, { useEffect, useState, useRef } from "react";
import "./timeline.scss";
import emoji from "../../assets/images/emoji1.svg";
import angryEmoji from "../../assets/images/angry.svg";
import happyEmoji from "../../assets/images/happy.svg";
import neutralEmoji from "../../assets/images/neutral.svg";
import filterWhite from "../../assets/images/filter-white.svg";
import { useLocation } from "react-router-dom";
import AWS from 'aws-sdk';
import Papa from 'papaparse';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";


// import dotenv from 'dotenv';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// Configure the AWS SDK with your access key and secret key
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const s3 = new AWS.S3();

// async function fetchCSVFromS3(bucket, key) {
//   return new Promise((resolve, reject) => {
//     s3.getObject({ Bucket: bucket, Key: key }, (err, data) => {
//       if (err) {
//         reject(err);
//         return;
//       }
//       resolve(data.Body.toString());
//     });
//   });
// }

// async function fetchCSVFromS3(bucket, prefix) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       // List objects in the specified folder
//       const listObjectsParams = {
//         Bucket: bucket,
//         Prefix: prefix,
//       };

//       const listObjectsResult = await s3.listObjectsV2(listObjectsParams).promise();
//       if (listObjectsResult.Contents.length === 0) {
//         throw new Error(`No files found in folder "${prefix}"`);
//       }

//       // Get the first file in the folder
//       const firstFileKey = listObjectsResult.Contents[0].Key;
//       console.log('Fetching file:', firstFileKey);

//       // Fetch the first file
//       const getObjectParams = {
//         Bucket: bucket,
//         Key: firstFileKey,
//       };

//       s3.getObject(getObjectParams, (err, data) => {
//         if (err) {
//           reject(err);
//           return;
//         }
//         resolve(data.Body.toString());
//       });
//     } catch (error) {
//       reject(error);
//     }
//   });
// }


async function fetchCSVFromS3(bucket, prefix) {
  return new Promise(async (resolve, reject) => {
    try {
      // List objects in the specified folder
      const listObjectsParams = {
        Bucket: bucket,
        Prefix: prefix,
      };

      const listObjectsResult = await s3.listObjectsV2(listObjectsParams).promise();
      if (listObjectsResult.Contents.length === 0) {
        throw new Error(`No files found in folder "${prefix}"`);
      }

      // Sort the files by LastModified timestamp (most recent first)
      listObjectsResult.Contents.sort((a, b) => {
        if (a.LastModified > b.LastModified) {
          return -1;
        } else if (a.LastModified < b.LastModified) {
          return 1;
        }
        return 0;
      });

      // Get the latest file in the folder
      const latestFileKey = listObjectsResult.Contents[0].Key;
      console.log('Fetching file:', latestFileKey);

      // Fetch the latest file
      const getObjectParams = {
        Bucket: bucket,
        Key: latestFileKey,
      };

      s3.getObject(getObjectParams, (err, data) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(data.Body.toString());
      });
    } catch (error) {
      reject(error);
    }
  });
}



function getVideoDuration(url) {
  return new Promise((resolve, reject) => {
    const videoElement = document.createElement('video');

    videoElement.onloadedmetadata = function() {
      resolve(videoElement.duration);
    };

    videoElement.onerror = function() {
      reject('Error loading video metadata');
    };

    videoElement.src = url;
  });
}


// Chart.register(...registerables);


function TimelineDuration({ onEmojiClick, currentTime }) {
  const [csvData, setCsvData] = useState([]);
  const [angryArray, setAngryArray] = useState([]);
  const [happyArray, setHappyArray] = useState([]);
  const [neutralArray, setNeutralArray] = useState([]);
  const location = useLocation();
  const vidName = location.state?.vidName || '';
  const username = localStorage.getItem('username');
  const [progress, setProgress] = useState(0);

 
  const videoUrl = `https://d2lzom8fkne0uo.cloudfront.net/userfiles/${vidName}`;

  const dateString = vidName.match(/\d{2}-\d{2}-\d{4}_\d{2}-\d{2}-\d{2}-\d{3}/)[0];
  const [datePart, timePart] = dateString.split('_');
  const [month, day, year] = datePart.split('-');
  const [hour, minute, second, millisecond] = timePart.split(/[-]/);


  const originalTimestamp = Date.UTC(
    parseInt(year),
    parseInt(month) - 1, // Month is zero-indexed
    parseInt(day),
    parseInt(hour),
    parseInt(minute),
    parseInt(second),
    parseInt(millisecond)
  );
    console.log(originalTimestamp)
    console.log("username check: ",username)
  // const originalTimestamp = 1679909203138;
  
  const [duration, setDuration] = useState(0);
  const [chartData, setChartData] = useState(null);

  const esportsResults = async () => {
    try {
      const eSportcsvContent = await fetchCSVFromS3(
        'esports-output',
        `${username}/radar_chart/Game_Emotion_Analysis.html`
      );

      // Parse the HTML table content
      const parser = new DOMParser();
      const doc = parser.parseFromString(eSportcsvContent, 'text/html');
      const tableRows = doc.querySelectorAll('tbody tr');
      const categories = [];
      const values = [];

      tableRows.forEach(row => {
        const cells = row.querySelectorAll('td');
        const category = cells[0].innerText;
        const value = parseFloat(cells[1].innerText);

        categories.push(category);
        values.push(value);
      });

      // Prepare chartData for the Radar chart
      const data = {
        labels: categories,
        datasets: [
          {
            label: 'Game Emotion Analysis',
            data: values,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
          },
        ],
      };

      setChartData(data); // Update the state
      console.log("esports file",data)
    } catch (error) {
      console.error('Error fetching and parsing HTML:', error);
    }
  };

  useEffect(() => {
    async function fetchAndParseCSV() {
      try {
        const csvContent = await fetchCSVFromS3(
          'immersely-game-outputs',
          // 'Siddharth/Goodboi79-GameState-rocket_league.csv'
          `${username}/${username}`
        );

        const parsedData = Papa.parse(csvContent, { header: true });
        console.log("csv file",parsedData)
        let angryArray = [];
        let happyArray = [];
        let neutralArray = [];
          // Loop through parsedData and push timestamps to corresponding emotion arrays
          for (const row of parsedData.data) {
            const emotion = row.emotions;
            // const timestamp = parseFloat(row.timestamp) - 3600000;
            const timestamp = parseFloat(row.timestamp) - new Date (parseFloat(row.timestamp)).getTimezoneOffset()*60*1000;
            // console.log("this is the changing timestamp", timestamp)
            // Subtract originalTimestamp, convert to seconds, and round to the nearest second
            const adjustedTimestamp = Math.round(((timestamp - originalTimestamp) / 1000));
            console.log("adjested time", adjustedTimestamp )
            
            switch (emotion) {
              case 'Angry':
                angryArray.push(adjustedTimestamp);
                break;
              case 'Happy':
                happyArray.push(adjustedTimestamp);
                break;
              case 'Neutral':
                neutralArray.push(adjustedTimestamp);
                break;
              // Add more cases for other emotions if needed
            }
          }
        setCsvData(parsedData.data);
        setAngryArray(angryArray);
        setHappyArray(happyArray);
        setNeutralArray(neutralArray);
      } catch (error) {
        console.error('Error fetching and parsing CSV:', error);
      }
    }
  
    // const esportsResults = async () => {
    //   try {
    //     // Fetch data from S3 bucket
    //     const eSportcsvContent = await fetchCSVFromS3(
    //       'esports-output',
    //       'Goodboi79/radar_chart/Game_Emotion_Analysis.html'
    //     );

    //     // Parse the HTML table content
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(eSportcsvContent, 'text/html');
    //     const rows = doc.querySelectorAll('tbody tr');
    //     const categories = [];
    //     const values = [];

    //     rows.forEach(row => {
    //       const cells = row.querySelectorAll('td');
    //       categories.push(cells[0].textContent); // First column is Category
    //       values.push(parseFloat(cells[1].textContent)); // Second column is Value
    //     });

    //     if (chartRef.current) {
    //       chartRef.current.destroy();
    //     }

    //     // Create a radar chart using pure JavaScript and Chart.js
    //     const ctx = document.getElementById('radarChart').getContext('2d');
    //     chartRef.current = new Chart(ctx, {
    //       type: 'radar',
    //       data: {
    //         labels: categories,
    //         datasets: [{
    //           label: 'Game Emotion Analysis',
    //           data: values,
    //           backgroundColor: 'rgba(255, 99, 132, 0.2)',
    //           borderColor: 'rgba(255, 99, 132, 1)',
    //           borderWidth: 2,
    //         }]
    //       },
    //       options: {
    //         scales: {
    //           r: {
    //             angleLines: {
    //               display: true
    //             },
    //             suggestedMin: 0,
    //             suggestedMax: Math.max(...values),
    //           }
    //         }
    //       }
    //     });
    //   } catch (error) {
    //     console.error('Error fetching and parsing HTML:', error);
    //   }
    // };

    async function fetchVideoDuration() {
      try {
        const videoDuration = await getVideoDuration(videoUrl);
        setDuration(Math.ceil(videoDuration));
        
      } catch (error) {
        console.error('Error fetching video duration:', error);
      }
    }
    setProgress((currentTime / duration) * 100);

    fetchAndParseCSV();
    fetchVideoDuration();
    esportsResults();
  }, [currentTime, duration]);

 


  let totalSeconds = duration;
  const secondsPerMinLine = 10;
  const secondsPerSecLine = 60;

  function getEmojiForIndex(index) {
    const currentSecond = index;
   
    let emojiComponent = null;
  
    const filteredAngryArray = angryArray.filter((val) => val !== 0);
    const filteredHappyArray = happyArray.filter((val) => val !== 0);
    const filteredNeutralArray = neutralArray.filter((val) => val !== 0);
    // console.log(angryArray)
    const handleEmojiClick = (time) => {
      time = currentSecond;
      console.log(`Emoji clicked at ${currentSecond} seconds.`);
      if (onEmojiClick) {
        onEmojiClick(time);
      }
    };
  
    if (filteredAngryArray.includes(currentSecond)) {
      emojiComponent = <img src={angryEmoji} alt="angry emoji" onClick={handleEmojiClick}/>;
    } else if (filteredHappyArray.includes(currentSecond)) {
      emojiComponent = <img src={happyEmoji} alt="happy emoji" onClick={handleEmojiClick}/>;
    } else if (filteredNeutralArray.includes(currentSecond)) {
      emojiComponent = <img src={neutralEmoji} alt="neutral emoji" onClick={handleEmojiClick}/>;
    }
  
    if (emojiComponent) {
      return (
        <div
          key={index}
          style={{
            position: "absolute",
            left: `${(index / totalSeconds) * 100}%`,
          }}
        >
          {emojiComponent}
        </div>
      );
    }
  
    return null;
  }

  


  return (
    <div className="timeline-progress">
      <div className="justify-between align-center">
        <div className="w-100">
        <div className="progress-line-wrapper" >
        <div className="emojies-above" >
        {[...Array(totalSeconds)].map((_, index) => {
          return getEmojiForIndex(index);
        })}
        </div>
          {/* <div className="emojies justify-between px-5 mb-4">
            <img src={emoji} alt="emoji" />
            <img src={emoji} alt="emoji" />
            <img src={emoji} alt="emoji" />
            <img src={emoji} alt="emoji" />
            <img src={emoji} alt="emoji" />
            <img src={emoji} alt="emoji" />
          </div> */}
          <div className="top-line"></div>
          <div className="progress-line justify-between px-3 white">
          {[...Array(totalSeconds)].map((_, index) => {
          if (index % secondsPerSecLine === 0) {
            return (
              <div>
                <div className="minLine"></div>
                <div className="sectext">{index / secondsPerSecLine}</div>
              </div>
            );
          } else if (index % secondsPerMinLine === 0) {
            return <div className="secline"></div>;
          } else {
            return null;
          }
        })}
          </div>
          <div
            className="progress-line-indicator"
            style={{ left: `${progress}%` }}
          ></div>
          {/* <TimelineDuration updatePlayer={updatePlayer} /> */}
          </div>
        </div>
        <div className="mt-4 pl-3">
          <button className="theme-btn theme-color shareBtn align-center">
            <img className="mr-1" src={filterWhite} alt="filter" />
            Filter
          </button>
        </div>
      </div>
        {/* Chart rendering */}
        {chartData ? (
              <Radar
                data={chartData}
                options={{
                  scales: {
                    r: {
                      angleLines: {
                        color: 'rgba(75, 192, 192, 0.5)', // Color of the lines radiating from the center
                      },
                      grid: {
                        color: 'rgba(75, 192, 192, 0.5)', // Color of the circular grid lines
                      },
                      ticks: {
                        beginAtZero: true,
                        max: Math.max(...chartData.datasets[0].data),
                        color: 'rgba(255, 159, 64, 1)',
                      },
                      pointLabels: {
                        color: 'rgba(153, 102, 255, 1)', // Color of the labels around the radar chart
                      },
                    },
                  },
                  elements: {
                    line: {
                      tension: 0.4, // Smooth curves
                      backgroundColor: 'rgba(255, 99, 132, 0.2)', // Color of the radar area fill
                      borderColor: 'rgba(255, 99, 132, 1)', // Color of the radar border
                    },
                  },
                  plugins: {
                    legend: {
                      display: true,
                      position: 'top',
                      labels: {
                        color: 'rgba(54, 162, 235, 1)', // Color of the legend text
                      },
                    },
                  },
                }}
              />
            ) : (
              <p>Loading chart...</p>
            )}
    </div>
  );
}
export default TimelineDuration;
